import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=7ff820de&scoped=true"
var script = {}
import style0 from "./Navbar.vue?vue&type=style&index=0&id=7ff820de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff820de",
  null
  
)

export default component.exports